<template>
    <div>
        <header class="header frame-h-medium">
            <span class="header__svg" :style="{ 'background-image': `url(${logo})` }" alt=""></span>
            <LanguageSwitch
                class="header__languages"
                :languages="languages"
                :language="language"
                @select="select" />
        </header>

        <Hero :image="hero" :claim="``" />
    </div>
</template>

<script>
    export default {
        name: "DefaultHeader",
        props: {
            logo: String,
            hero: String,
            select: Function,
            language: String,
            languages: Object
        }
    }
</script>

<style scoped>

</style>
